import { ReactNode } from 'react';
import { RoutePath } from 'enums/Routes';

export enum DashboardTileLayout {
  Shared = 'shared',
  Full = 'full',
}

export enum DashboardTileIconTone {
  Green = 'green',
  Purple = 'purple',
  Blue = 'blue',
  Orange = 'orange',
  Red = 'red',
}

export enum DashboardTileActionType {
  Sheet = 'sheet',
  Navigate = 'navigate',
}

export type DashboardTileAction =
  | { type: DashboardTileActionType.Sheet; render: (onClose: () => void) => ReactNode }
  | { type: DashboardTileActionType.Navigate; path: RoutePath };

export interface DashboardTile {
  id: string;
  priority: number;
  visible: boolean;
  layout: DashboardTileLayout;
  highlight?: boolean;
  title: string;
  description: string;
  icon: ReactNode;
  iconTone: DashboardTileIconTone;
  analyticsEvent?: string;
  action: DashboardTileAction;
}

export interface PackedTile extends DashboardTile {
  isFull: boolean;
}

export type TileRow = PackedTile[];
